import { useState } from "react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { BRAND_COLORS, withAlpha } from "../../lib/bookingStatus";

export function ShareGuestDialog({ propertyId, onClose }) {
  const { lang } = useI18n();
  const de = lang !== "en";
  const [form, setForm] = useState({ guest_email: "", guest_name: "", message: "" });
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await api.post(`/properties/${propertyId}/handbook-email`, form);
      toast.success(de ? "Handbuch an Gast versendet." : "Handbook sent to guest.");
      onClose();
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally { setSending(false); }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: `${withAlpha(BRAND_COLORS.navyDark, 0.75)}` }}
      data-testid="handbook-share-dialog"
      onClick={onClose}
    >
      <div className="bg-ivory max-w-lg w-full border border-gold/40 p-8" onClick={(e) => e.stopPropagation()}>
        <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>{de ? "Gast-Vorabinfo" : "Pre-arrival info"}</div>
        <h3 className="font-display text-2xl text-navy mb-2">{de ? "Handbuch per E-Mail senden" : "Email the handbook"}</h3>
        <p className="text-[13px] text-navy-dark/70 mb-6 leading-relaxed">
          {de
            ? "Der Gast erhält alle wichtigen Objekt-Informationen (WLAN, Heizung, Nachbarn, Notfallkontakte) direkt per E-Mail — kein App-Login nötig."
            : "The guest receives all key property information (Wi-Fi, heating, neighbours, emergency contacts) directly by email — no app login required."}
        </p>
        <input
          data-testid="share-email-input"
          required type="email" placeholder={de ? "E-Mail des Gasts" : "Guest email"}
          value={form.guest_email}
          onChange={(e) => setForm({ ...form, guest_email: e.target.value })}
          className="w-full bg-white border border-navy/20 focus:border-gold focus:outline-none px-4 py-3 mb-3 text-navy-dark"
        />
        <input
          placeholder={de ? "Name des Gasts (optional)" : "Guest name (optional)"}
          value={form.guest_name}
          onChange={(e) => setForm({ ...form, guest_name: e.target.value })}
          className="w-full bg-white border border-navy/20 focus:border-gold focus:outline-none px-4 py-3 mb-3 text-navy-dark"
        />
        <textarea
          placeholder={de ? "Persönliche Nachricht (optional)" : "Personal message (optional)"}
          rows={3}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="w-full bg-white border border-navy/20 focus:border-gold focus:outline-none px-4 py-3 mb-6 text-navy-dark"
        />
        <div className="flex items-center gap-3">
          <button
            data-testid="share-send-btn"
            disabled={sending || !form.guest_email}
            onClick={send}
            className="bg-navy text-ivory px-6 py-2.5 text-[12px] tracking-[0.15em] uppercase hover:bg-navy-dark transition-colors disabled:opacity-50"
            style={{ background: BRAND_COLORS.navy }}
          >
            {sending ? (de ? "Wird versendet…" : "Sending…") : (de ? "Absenden" : "Send")}
          </button>
          <button
            onClick={onClose}
            className="text-[12px] tracking-[0.15em] uppercase text-navy-dark/60 hover:text-navy transition-colors"
          >
            {de ? "Abbrechen" : "Cancel"}
          </button>
        </div>
      </div>
    </div>
  );
}
